<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-tooltip bottom v-if="Delete">
            <v-btn text icon color="red" v-on="on" @click="doPromptRemove">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete Business Class</span>
          </v-tooltip>
          <v-icon v-else>mdi-magnify</v-icon>
          <v-toolbar-title v-if="Delete">Delete Business Class</v-toolbar-title>
          <v-toolbar-title v-else>Query Business Class</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ busClsForm.busCls }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busClsDesc }}</v-subheader>
                <div class="queryValue">{{ busClsForm.busClsDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.busClsGrp"
                  :label="labels.busClsGrp"
                  :error-messages="errors.collect('busClsGrp')"
                  data-vv-name="busClsGrp"
                  :data-vv-as="labels.busClsGrp"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="hideGlanCode">
                <v-text-field
                  v-model="busClsForm.glAC"
                  :label="labels.glAC"
                  :error-messages="errors.collect('glAC')"
                  data-vv-name="glAC"
                  :data-vv-as="labels.glAC"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.busClsAppID"
                  :label="labels.busClsAppID"
                  :error-messages="errors.collect('busClsAppID')"
                  data-vv-name="busClsAppID"
                  :data-vv-as="labels.busClsAppID"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.perGst }}</v-subheader>
                <div class="queryValue">{{ formatBoolean(busClsForm.perGst) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.defTariff"
                  :label="labels.defTariff"
                  :error-messages="errors.collect('defTariff')"
                  data-vv-name="defTariff"
                  :data-vv-as="labels.defTariff"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.ifrsClsGrp"
                  :label="labels.ifrsClsGrp"
                  :error-messages="errors.collect('ifrsClsGrp')"
                  data-vv-name="ifrsClsGrp"
                  :data-vv-as="labels.ifrsClsGrp"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.portfolio"
                  :label="labels.portfolio"
                  :error-messages="errors.collect('portfolio')"
                  data-vv-name="portfolio"
                  :data-vv-as="labels.portfolio"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.giaClsGrp"
                  :label="labels.giaClsGrp"
                  :error-messages="errors.collect('giaClsGrp')"
                  data-vv-name="giaClsGrp"
                  :data-vv-as="labels.giaClsGrp"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.subPortfolio"
                  :label="labels.subPortfolio"
                  :error-messages="errors.collect('subPortfolio')"
                  data-vv-name="subPortfolio"
                  :data-vv-as="labels.subPortfolio"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-chart-areaspline</v-icon><span class="headerTitle">Accumulation</span></div>
              </v-expansion-panel-header>
              <!-- <div slot="header">Accumulation</div> -->
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.accumType"
                            :label="labels.accumType"
                            :error-messages="errors.collect('accumType')"
                            data-vv-name="accumType"
                            :data-vv-as="labels.accumType"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.ttyCesMeth"
                            :label="labels.ttyCesMeth"
                            :error-messages="errors.collect('ttyCesMeth')"
                            data-vv-name="ttyCesMeth"
                            :data-vv-as="labels.ttyCesMeth"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.riCat"
                            :label="labels.riCat"
                            :error-messages="errors.collect('riCat')"
                            data-vv-name="riCat"
                            :data-vv-as="labels.riCat"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-settings-box</v-icon><span class="headerTitle">Miscellaneous</span></div>
              </v-expansion-panel-header>
              <!-- <div slot="header">Miscellaneous</div> -->
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.vesYrMand }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.vesYrMand) }}</div>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.perIndGrp }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.perIndGrp) }}</div>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.perSubItem }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.perSubItem) }}</div>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.wrkmanComp }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.wrkmanComp) }}</div>
                        </v-flex>
                         <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.prtFireRisk }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.prtFireRisk) }}</div>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.prtTotSi }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.prtTotSi) }}</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-motorbike</v-icon><span class="headerTitle">Motor</span></div>
              </v-expansion-panel-header>
              <!-- <div slot="header">Motor</div> -->
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <!--
                      <v-flex xs6>
                        <v-text-field v-model="busClsForm.vehGrp" :label="labels.vehGrp" :error-messages="errors.collect('vehGrp')" data-vv-name="vehGrp" :data-vv-as="labels.vehGrp" readonly></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-subheader class="queryLabel">{{labels.minAge}}</v-subheader>
                        <div class="queryValue">{{busClsForm.minAge}}</div>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="queryLabel">{{labels.maxAge}}</v-subheader>
                        <div class="queryValue">{{busClsForm.maxAge}}</div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-subheader class="queryLabel">{{labels.perTonnage}}</v-subheader>
                        <div class="queryValue">{{formatBoolean(busClsForm.perTonnage)}}</div>
                      </v-flex>
                      -->
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.vehGrp"
                            :label="labels.vehGrp"
                            :error-messages="errors.collect('vehGrp')"
                            data-vv-name="vehGrp"
                            :data-vv-as="labels.vehGrp"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.defVehUsg"
                            :label="labels.defVehUsg"
                            :error-messages="errors.collect('defVehUsg')"
                            data-vv-name="defVehUsg"
                            :data-vv-as="labels.defVehUsg"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.giaVeh"
                            :label="labels.giaVeh"
                            :error-messages="errors.collect('giaVeh')"
                            data-vv-name="giaVeh"
                            :data-vv-as="labels.giaVeh"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.allowYr }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.allowYr) }}</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon> mdi-account-remove</v-icon><span class="headerTitle">Personal Accident</span></div>
              </v-expansion-panel-header>
              <!-- <div slot="header">Personal Accident</div> -->
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.noLive"
                            :label="labels.noLive"
                            :error-messages="errors.collect('noLive')"
                            data-vv-name="noLive"
                            :data-vv-as="labels.noLive"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="queryLabel">{{ labels.nricMand }}</v-subheader>
                          <div class="queryValue">{{ formatBoolean(busClsForm.nricMand) }}</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ busClsForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(busClsForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newBusCls">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ busClsForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(busClsForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
            <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records. ( {{ busClsForm.busCls }} )</confirm>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { busClsAppIdList, ttyCesMethList, riCatList, noLivesList } from './BusClsCustomRuleAndList'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      toogleArray: [false, false, false, false],
      labels: {
        // General
        busCls: 'Code',
        busClsDesc: 'Description',
        busClsGrp: 'Class Group',
        glAC: 'GL Analysis Code',
        busClsAppID: 'Application ID',
        perGst: 'Apply GST',
        ifrsClsGrp: 'IFRS Class Group',
        portfolio: 'Portfolio',
        giaClsGrp: 'GIA Class Group',
        subPortfolio: 'Sub-portfolio',
        // Accumulation
        accumType: 'Accumulation Type',
        ttyCesMeth: 'Treaty Cession Method',
        riCat: 'RI Category',
        // Miscellaneous
        vesYrMand: 'Make Vessel Year Built Mandatory',
        perIndGrp: 'Permit Industry Group',
        perSubItem: 'Permit SubItem',
        wrkmanComp: 'Workmen`s Compensation Class',
        prtFireRisk: 'Print Fire Risk Details',
        prtTotSi: 'Print Total Sum Insured',
        // Motor
        defTariff: 'Default Tariff',
        vehGrp: 'Default Vehicle Group',
        /* minAge: "Minimum Driver's Age",
        maxAge: "Maximum Driver's Age",
        perTonnage: 'Permit Tonnage',
        */
        defVehUsg: 'Default Vehicle Usage',
        allowYr: 'Allow Year for Motor Registration',
        giaVeh: 'GIA Vehicle Ref',
        // Personal Accident
        noLive: 'No. of Lives',
        nricMand: 'NRIC Mandatory',
        // Audit
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      busClsForm: {
        // General
        busCls: null,
        busClsDesc: null,
        busClsGrp: null,
        glAC: null,
        busClsAppID: null,
        perGst: false,
        ifrsClsGrp: null,
        portfolio: null,
        giaClsGrp: null,
        subPortfolio: null,
        // Accumulation
        accumType: null,
        ttyCesMeth: null,
        riCat: null,
        // Miscellaneous
        vesYrMand: false,
        perIndGrp: false,
        perSubItem: false,
        wrkmanComp: false,
        prtFireRisk: false,
        prtTotSi: false,
        // Motor
        defTariff: null,
        vehGrp: null,
        /* minAge: 0,
        maxAge: 0,
        perTonnage: false,
        */
        defVehUsg: null,
        allowYr: false,
        giaVeh: null,
        // Personal Accident
        noLive: null,
        nricMand: false,
        // Audit
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null
      },
      busClsGrpList: [],
      glanCodeList: [],
      accumTypeList: [],
      tariffList: [],
      vehGrpList: [],
      busClsAppIdList: [],
      ttyCesMethList: [],
      riCatList: [],
      noLivesList: [],
      newBusCls: false,
      hideGlanCode: true,
      promptRemove: false,
      selectedBusCls: {
        busCls: null,
        busClsDesc: null
      },
      loading: false,
      sideFunction: [
        {
          text: 'Permit Benefit',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'pmtBenefitPerBusClsList' }
        },
        {
          text: 'Permit Tariff',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'pmtTariffPerBusCls',
            params: { incomingBusCls: 'noBusCls', incomingTariff: 'noTariff', incomingBusClsDesc: 'noBusClsDesc', incomingTariffDesc: 'noTariffDesc' }
          }
        },
        {
          text: 'GIA Class Group',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'giaClsGrp'
          }
        },
        {
          text: 'IFRS Class Group',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'ifrsClsGrp'
          }
        },
        {
          text: 'Portfolio',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'portfolio'
          }
        },
        {
          text: 'Sub-Portfolio',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'subPortfolio'
          }
        }
      ],
      vehUsgList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    displayLabel(value, field) {
      var list = []
      var returnLabel = ''
      if (field === 'busClsGrp') {
        list = this.busClsGrpList
      } else if (field === 'glAC') {
        list = this.glanCodeList
      } else if (field === 'busClsAppID') {
        list = this.busClsAppIdList
      } else if (field === 'accumType') {
        list = this.accumTypeList
      } else if (field === 'ttyCesMeth') {
        list = this.ttyCesMethList
      } else if (field === 'riCat') {
        list = this.riCatList
      } else if (field === 'defTariff') {
        list = this.tariffList
      } else if (field === 'vehGrp') {
        list = this.vehGrpList
      } else if (field === 'noLive') {
        list = this.noLivesList
      } else if (field === 'defVehUsg') {
        list = this.vehUsgList
      }

      for (var i in list) {
        if (list[i].value === value) {
          returnLabel = list[i].label
        }
      }
      return returnLabel
    },
    async doFetch() {
      const apiURI = this.busClsMenu.getBusCls
      if (apiURI) {
        this.loading = true
        try {
          const expand = { busCls: this.busCls }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.busClsForm.busCls = data.busCls.busCls
            this.busClsForm.busClsDesc = data.busCls.busClsDesc
            this.busClsForm.busClsGrp = this.displayLabel(data.busCls.busClsGrp, 'busClsGrp')
            this.busClsForm.glAC = this.displayLabel(data.busCls.glAC, 'glAC')
            this.busClsForm.busClsAppID = this.displayLabel(data.busCls.busClsAppID, 'busClsAppID')
            this.busClsForm.perGst = data.busCls.perGst
            this.busClsForm.ifrsClsGrp = data.busCls.ifrsClsGrp
            this.busClsForm.giaClsGrp = data.busCls.giaClsGrp
            this.busClsForm.portfolio = data.busCls.portfolio
            this.busClsForm.subPortfolio = data.busCls.subPortfolio
            // Accumulation
            this.busClsForm.accumType = this.displayLabel(data.busCls.accumType, 'accumType')
            this.busClsForm.ttyCesMeth = this.displayLabel(data.busCls.ttyCesMeth, 'ttyCesMeth')
            this.busClsForm.riCat = this.displayLabel(data.busCls.riCat, 'riCat')
            // Miscellaneous
            this.busClsForm.vesYrMand = data.busCls.vesYrMand
            this.busClsForm.perIndGrp = data.busCls.perIndGrp
            this.busClsForm.perSubItem = data.busCls.perSubItem
            this.busClsForm.wrkmanComp = data.busCls.wrkmanComp
            this.busClsForm.prtFireRisk = data.busCls.prtFireRisk
            this.busClsForm.prtTotSi = data.busCls.prtTotSi
            // Motor
            this.busClsForm.defTariff = this.displayLabel(data.busCls.defTariff, 'defTariff')
            this.busClsForm.vehGrp = this.displayLabel(data.busCls.vehGrp, 'vehGrp')
            /* this.busClsForm.minAge = data.busCls.minAge
            this.busClsForm.maxAge = data.busCls.maxAge
            this.busClsForm.perTonnage = data.busCls.perTonnage
            */
            this.busClsForm.defVehUsg = this.displayLabel(data.busCls.defVehUsg, 'defVehUsg')
            this.busClsForm.giaVeh = data.busCls.giaVeh
            this.busClsForm.allowYr = data.busCls.allowYr
            // Personal Accident
            this.busClsForm.noLive = this.displayLabel(data.busCls.noLive, 'noLive')
            this.busClsForm.nricMand = data.busCls.nricMand
            // Audit
            this.busClsForm.createdName = data.busCls.createdName
            this.busClsForm.createdDate = data.busCls.createdDate
            this.busClsForm.modifiedName = data.busCls.modifiedName
            this.busClsForm.modifiedDate = data.busCls.modifiedDate

            // Put SideFunction Param
            for (var i = 0; i < this.sideFunction.length; i++) {
              if (this.sideFunction[i].params.name === 'pmtTariffPerBusCls') {
                this.sideFunction[i].params.params.incomingBusCls = data.busCls.busCls
                this.sideFunction[i].params.params.incomingTariff = 'noTariff'
                this.sideFunction[i].params.params.incomingBusClsDesc = data.busCls.busClsDesc
                this.sideFunction[i].params.params.incomingTariffDesc = 'noTariffDesc'
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCheckHideGlanCode() {
      const apiURI = this.busClsMenu.chkHideGlanCode
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.hideGlanCode = data.hideGlanCode
          }
        } catch (err) {
          this.hideGlanCode = true
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSetList() {
      const getState = this.$store.state.busClsParam
      this.busClsGrpList = getState.busClsGrpList
      this.glanCodeList = getState.glanCodeList
      this.accumTypeList = getState.accumTypeList
      this.tariffList = getState.tariffList
      this.vehGrpList = getState.vehGrpList
      this.busClsAppIdList = busClsAppIdList
      this.ttyCesMethList = ttyCesMethList
      this.riCatList = riCatList
      this.noLivesList = noLivesList
      this.vehUsgList = getState.vehUsgList
    },
    doPromptRemove() {
      this.resetMessages()
      this.selectedBusCls.busCls = this.busClsForm.busCls
      this.selectedBusCls.busClsDesc = this.busClsForm.busClsDesc
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.busClsMenu.deleteBusCls
      if (apiURI) {
        const expand = this.selectedBusCls
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.$router.push({ name: 'busClsList' })
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    busCls() {
      return this.$route.params.busCls
    },
    Delete() {
      return this.$route.params.delete
    },
    busClsMenu() {
      return this.$store.state.busClsParam.menu
    }
  },
  created() {
    this.doCheckHideGlanCode()
    this.doSetList()
    this.doFetch()
  },
  components: {
    SideFunctionMenu
  },
  mixins: [MessageMixin]
}
</script>
